import {
  Box,
  Button,
  Flex,
  Image,
  Modal,
  ModalBody,
  ModalContent,
  ModalOverlay,
  Text,
  VStack,
} from '@chakra-ui/react';
import React from 'react';

export default function PausedStoresInfoModal({
  isOpen,
  setWelcomeOpen,
  storesNotServiceable,
}) {
  return (
    <Modal
      isOpen={isOpen}
      isCentered
      closeOnOverlayClick={false}
      closeOnEsc={false}
      size="xl"
    >
      <ModalOverlay />
      <ModalContent roundedTopRight="0" roundedBottomLet="0">
        <ModalBody p="0" m="0" className="blockBg">
          <Flex direction="column" roundedTopLeft="10" roundedBottomRight="10">
            <Flex justifyContent="flex-end">
              <Box w="35%" h="5px" bg="brand.red" roundedBottomLeft="md" />
            </Flex>
            <VStack textAlign="center" spacing="3" p="10" h="400px" mt="10">
              <Image
                src={require('../../../assets/logo/Full-Logo.svg')}
                w="170px"
              />
              <Text color="brand.red" fontSize="lg" mt="10">
                Welcome to 1800Spirits
              </Text>
              {storesNotServiceable?.length > 0 && (
                <>
                  <Text fontWeight="bold" fontSize="lg" mt="10">
                    Orders are paused for below stores :
                    <br />
                    {storesNotServiceable?.map((notServiceableStore) => {
                      return <Text>{notServiceableStore.storeName}</Text>;
                    })}
                  </Text>
                </>
              )}

              <Flex pb="8" direction="row" pt="5">
                <Box>
                  <Button
                    type="submit"
                    _hover={{ background: 'brand.red' }}
                    onClick={() => {
                      setWelcomeOpen(false);
                    }}
                  >
                    Close
                  </Button>
                </Box>
              </Flex>
            </VStack>
            <Box
              w="35%"
              h="5px"
              bg="brand.red"
              roundedTopRight="md"
              alignItems="flex-end"
            />
          </Flex>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}
